/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssuranceEditDto
 */
export interface AssuranceEditDto {
    /**
     * 
     * @type {number}
     * @memberof AssuranceEditDto
     */
    idsiegeSocialCompagnieAssurance?: number;
    /**
     * 
     * @type {number}
     * @memberof AssuranceEditDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {number}
     * @memberof AssuranceEditDto
     */
    idcompagnieAssurance?: number;
    /**
     * 
     * @type {string}
     * @memberof AssuranceEditDto
     */
    numeroPolice?: string | null;
}

/**
 * Check if a given object implements the AssuranceEditDto interface.
 */
export function instanceOfAssuranceEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AssuranceEditDtoFromJSON(json: any): AssuranceEditDto {
    return AssuranceEditDtoFromJSONTyped(json, false);
}

export function AssuranceEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssuranceEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeSocialCompagnieAssurance': !exists(json, 'idsiegeSocialCompagnieAssurance') ? undefined : json['idsiegeSocialCompagnieAssurance'],
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'idcompagnieAssurance': !exists(json, 'idcompagnieAssurance') ? undefined : json['idcompagnieAssurance'],
        'numeroPolice': !exists(json, 'numeroPolice') ? undefined : json['numeroPolice'],
    };
}

export function AssuranceEditDtoToJSON(value?: AssuranceEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeSocialCompagnieAssurance': value.idsiegeSocialCompagnieAssurance,
        'idsiegeSocial': value.idsiegeSocial,
        'idcompagnieAssurance': value.idcompagnieAssurance,
        'numeroPolice': value.numeroPolice,
    };
}

